const Constants = Object.freeze({
  USER: "user",
  MESES_ESTCUENTA_OFV: "MESES_ESTCUENTA_OFV",
  ACTIVAR_BPMS_BENEFICIO: "ACTIVAR_BPMS_BENEFICIO",
  MAX_LOGIN_INTENTOS: "MAX_LOGIN_INTENTOS",
  BPMS_TASKS: "bpmstasks",
  APPURLS: {
    DASHBOARD: "/",
    LOGIN: "/login",
    SIGNUP: "/signup",
    RECOVER_PASSWORD: "/recover-password",
    RESET_PASSWORD: "/reset-password",

    ACCOUNT_STATEMENTS: "/account-statements",
    DISTRIBUTION_FUNDS: "/distribution-funds",
    REQUESTS_SERVICES_CLAIMS: "/requests-services-claims",
    BENEFITS: "/benefits",
    BPMS_TASK: "/bpmstasks/:code",
    CALCULATORS: "/calculators",
    PROFILE: "/profile",

    NOT_FOUND: "/not-found",

    /* PUBLIC URLS */
    PUBLIC_CALCULATORS: "/public-calculators",
    PUBLIC_ACCOUNT_STATEMENTS: "/public-account-statements",
    PUBLIC_JOB: "/public-job",
    PUBLIC_SMS: "/public-sms",
    PUBLIC_SMS_GUID: "/sms/:guid",
  },
  APIURLS: {
    LOGIN: "/api/Auth/Afiliados",
    CHANGEPASS: "/api/Afiliados/CambiarClave",
    LOGINFALLOS: "/api/Auth/GetLoginFallos/",
    UPDATELOGINFALLOS: "/api/Auth/UpdateLoginFallos/",
    

    RESUMENCUENTA: "/api/Afiliado/Cuenta/Resumen",
    RENTABILIDADPORMESES: "/api/Afiliado/Cuenta/RentabilidadPorMeses/", // + meses
    BALANCECCI: "/api/Afiliado/Cuenta/BalanceCCI/", // + codCuenta
    ESTADOCUENTASMS: "/api/Afiliado/Cuenta/EstadoCuentaSMS/", // + guid
    ULTIMOAPORTE: "/api/Afiliado/Cuenta/UltimoAporte",
    EVOLUTIVO: "/api/Afiliado/Cuenta/Evolutivo/", // + meses
    ESTADOSCUENTA: "/api/Afiliado/Cuenta/Estado",
    OBTENERAFILIADO: "/api/Afiliado/Consulta",
    VALIDATEAFILIADO: "/api/Afiliado/IsAfiliado/", // + cedula

    PREGUNTASSEGURIDAD: "/api/PreguntasSeguridad/SinRespuestas/", // + cédula
    PREGUNTASSEGURIDADSMS: "/api/PreguntasSeguridad/SinRespuesta/2/", // + cédula
    VALIDARPREGUNTASSEGURIDAD: "/api/PreguntasSeguridad/ValidarRespuestas",
    RESUMENRESPUESTAS: "/api/Afiliado/Cuenta/EstadosRespuestas",
    RESUMENCUENTACEDULA: "/api/Afiliado/Cuenta/EstadoCuentaCedula",
    PUBLICREPORTEESTADOCUENTA:
      "/api/Afiliado/Consulta/EstadoCuentaPDFRespuestas",
    PUBLICREPORTEESTADOCUENTAPUBLICSMS:
      "/api/Afiliado/Consulta/EstadoCuentaPDFPublicSMS",

    BENEFICIOS: "/api/Beneficios",
    GETREQUISITOS: "/api/Beneficios/Requisitos/", // + codBeneficio
    SOLICITUDESBYFILTROS: "/api/Solicitudes/ByFiltros",

    OBTENERVALORPORCODIGO: "/api/Parametros/ObtenerValorPorCodigo/",

    BPMS: {
      EXTERNALLOGIN: "/api/BPMS/ExternalLogin",
      EXTERNALLOGINPUNTUAL: "/api/BPMS/ExternalLoginPuntual"
    },

    TIPOSSOLICITUD: "/api/Solicitudes/Tipos",
    MOTIVOSRECLAMOS: "api/Solicitudes/ObtenerMotivosReclamo",
    //MOTIVOSRECLAMOS: "api/Solicitudes/ObtenerMotivosReclamos",
    OBTENERMEDIOS: "/api/Solicitudes/Medios",

    REPORTEESTADOCUENTA: "/api/Afiliado/Consulta/EstadoCuentaPDF", // + fecha

    CALCULATORS: {
      APORTES: "/api/Calculadoras/Aportes/", // + salario
      APORTESDETALLE: "/api/Calculadoras/AportesDetalle/", // + salario
      CALCULARFONDO: "/api/Calculadoras/CarcularFondo",
    },

    RECOVERPASS: "/api/Afiliados/SolicitarRecuperarClave",

    VALIDATETOKENPASS: "/api/Afiliados/ValidarTokenRecuperarClave/", // + guid
    RESETPASS: "/api/Afiliados/ResetearClave",

    PROVINCIAS: "/api/Direcciones/Provincias",
    MUNICIPIOS: "/api/Direcciones/Municipios/", // + idProvincia
    SECTORES: "/api/Direcciones/Sectores/", // + idMunicipio

    SOLICITUDESZENDESK: "/api/Solicitudes/Obtener",
    RECLAMOSZENDESK: "/api/Reclamos/Obtener",

    INVERSIONFONDOS: "/api/Calculadoras/ObtenerInversionFondos",
    DISTRIBUCIONBALANCE: "/api/Cuenta/DistribucionBalance",

    ACTUALIZARAFILIADO: "/api/Afiliado/Actualizar",

    SOLICITUDBYID: "/api/Solicitudes/Obtener/", // + id
    RECLAMOBYID: "/api/Reclamos/Obtener/", // + id
    GUARDARSOLICITUD: "/api/Solicitudes/Guardar",
    GUARDARRECLAMO: "/api/Reclamos/Guardar",

    VALIDATESOLICITUD: "/api/Beneficios/ValidarSolicitudBeneficio/", // + codBeneficio
    SAVEBENEFICIO: "/api/Solicitudes/SolicitudBeneficio",

    JOBREQUEST: "/api/Solicitudes/SolicitudEmpleo",

    ISAFILIADO: "/api/Afiliado/IsAfiliado/", // + cedula

    SOLICITUDAFILIACION: "/api/Solicitudes/SolicitudAfiliacion"
  },
});

export default Constants;
